import { createDrawerNavigator } from "@react-navigation/drawer";
import { MainStackParamList } from "./Navigation.types";
import { HomeScreen } from "../screens/home";
import { MyGamesScreen } from "../screens/my-games";
import { SideNav } from "../layout/components/side-menu";
import { StatsScreen } from "../screens/stats";
import { GameScreen } from "../screens/game";
import { AuthGuard } from "../common/guard";

const Main = createDrawerNavigator<MainStackParamList>();

export default function MainStack() {
  return (
    <AuthGuard>
      <Main.Navigator
        screenOptions={{ headerShown: false }}
        backBehavior="history"
        initialRouteName="home"
        drawerContent={(props) => <SideNav {...props} />}
      >
        <Main.Screen name="home" options={{ title: "Featured Game" }} component={HomeScreen} />
        <Main.Screen name="my-games" options={{ title: "My Games" }} component={MyGamesScreen} />
        <Main.Screen
          name="game"
          component={GameScreen}
          options={{ swipeEnabled: false, title: "Game", unmountOnBlur: true }}
        />
        <Main.Screen name="stats" options={{ title: "Rankings" }} component={StatsScreen} />
      </Main.Navigator>
    </AuthGuard>
  );
}
